<div class="dropdown-container" [style.width]="width">
  <label *ngIf="label" class="dropdown-label">{{ label }}</label>
  <div class="dropdown-wrapper" [style.width]="'100%'" [class.error]="hasError" [class.disabled]="disabled"
    [class.multiline]="multiline && multiple">
    <ng-select #ngSelect [items]="items" [ngModel]="model" (ngModelChange)="onModelChange($event)"
      [bindLabel]="bindLabel" [bindValue]="bindValue" [placeholder]="placeholder" [multiple]="multiple"
      [searchable]="shouldShowSearchable" [clearable]="clearable" [closeOnSelect]="shouldCloseOnSelect"
      [disabled]="disabled" [appendTo]="appendTo" [class.size-large]="size === 'large'"
      [class.size-medium]="size === 'medium'" [class.size-small]="size === 'small'"
      [class.multiline-mode]="multiline && multiple" [class.has-search]="searchable"
      [class.hide-search-icon]="!showIcon" class="app-basic-dropdown" dropdownPosition="bottom">

      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span *ngIf="renderAsHtml" [innerHTML]="getDisplayText(item, translateItems)"></span>
        <span *ngIf="!renderAsHtml">{{ translateItems ? (translationNamespace + ':' + item[ngSelect.bindLabel] |
          i18next) : item[ngSelect.bindLabel] }}</span>
      </ng-template>

      <ng-template ng-multi-label-tmp let-items="items" let-items$="items$" let-index="index" let-clear="clear">
        <div class="ng-select-selected-items">
          <span class="header-item all-selected-item" *ngIf="shouldShowAllSelectedLabel">
            {{ allSelectedLabel }}
          </span>
          <ng-container *ngIf="!shouldShowAllSelectedLabel">
            <ng-container *ngFor="let item of items">
              <span class="header-item" *ngIf="itemExists(item[ngSelect.bindValue])">
                <span *ngIf="renderAsHtml" [innerHTML]="getDisplayText(item, translateItems)"></span>
                <span *ngIf="!renderAsHtml">
                  <span *ngIf="translateItems">
                    {{ translationNamespace + ':' + item[ngSelect.bindLabel] | i18next }}
                  </span>
                  <span *ngIf="!translateItems">
                    {{ item[ngSelect.bindLabel] }}
                  </span>
                </span>
                <span>
                  <i class="far fa-times" (click)="clear(item)"></i>
                </span>
              </span>
            </ng-container>
          </ng-container>
        </div>
      </ng-template>

      <!-- Separate search input field in header -->
      <ng-template ng-header-tmp *ngIf="searchable || (multiple && showSelectAll)">
        <div class="dropdown-header">

          <!-- Search -->
          <app-filter-input *ngIf="searchable" [model]="searchTerm" placeholder="Enter keyword" [disabled]="disabled"
            size="small" width="100%" (modelChange)="onSearchInput($event)">
          </app-filter-input>

          <!-- Select All -->
          <div *ngIf="multiple && showSelectAll" class="select-all-option" (click)="toggleSelectAll()"
            [class.disabled]="disabled">

            <app-basic-checkbox [model]="isAllSelected"></app-basic-checkbox>

            <span class="select-all-label">
              {{ isAllSelected ? unselectAllText : selectAllText }}
            </span>

          </div>

        </div>
      </ng-template>

      <!-- Checkbox template for multiselect mode, Radio button for single select mode -->
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <div class="option-content" [class.multiselect]="multiple">
          <div *ngIf="multiple" [class.checked]="item$.selected">
            <app-basic-checkbox [model]="item$.selected"></app-basic-checkbox>
          </div>
          <div *ngIf="!multiple && showRadioButton" [class.checked]="item$.selected">
            <app-basic-radio [model]="item$.selected" [value]="true"
              (modelChange)="onModelChange($event)"></app-basic-radio>
          </div>
          <span *ngIf="renderAsHtml" class="option-label" [innerHTML]="getDisplayText(item, translateItems)"></span>
          <span *ngIf="!renderAsHtml" class="option-label">
            <span *ngIf="translateItems">{{translationNamespace + ':' + item[ngSelect.bindLabel]| i18next}}</span>
            <span *ngIf="!translateItems">{{item[ngSelect.bindLabel]}}</span>
          </span>
        </div>
      </ng-template>
    </ng-select>
  </div>
  <div *ngIf="hasError && errorText" class="error-text">
    <i class="fal fa-exclamation-circle error-icon"></i>
    {{ errorText }}
  </div>
</div>